export { default as PackagesDetailsItem } from './PackagesDetailsItem';
